import React from 'react';
import { FormLayout, Input, FixedLayout, Button } from '@vkontakte/vkui';
import DefaultPanel from "../classes/DefaultPanel";
import { connect } from "react-redux";
import {setRefundSum} from "../store/bills/actions";


class PanelRefund extends DefaultPanel {

    state = {
        maxSum: this.props.sum,
        error: false,
    };


	settings() {
		this.title = 'Возврат';
		this.hasBack = true;
		this.hasSwipe = true;
	}

	onChangeSum = (e) => {
        let num = e.target.value;
        num = num.replace(/,/g, '.');

        const error = (isNaN(num) || +num > this.state.maxSum || +num === 0);

        this.setState({ error });

	    this.props.dispatch(setRefundSum(num));
    };

	openRefundProcess = () => {
	    if (this.props.sum <= this.state.maxSum && this.props.sum > 0 && !isNaN(this.props.sum)) {
            this.openPage('refund-process');
        } else {
            this.setState({ error: true });
        }
    };

	renderPanel() {
		return(
			<React.Fragment>
				<FormLayout>
                    <Input
                        type="tel"
                        step="0.01"
                        inputMode="decimal"
                        placeholder="0"
                        className="huge-input"
                        defaultValue={ this.props.sum }
                        value={ this.props.sum }
                        onChange={ this.onChangeSum }
                        status={ this.state.error ? 'error' : 'default' }
                        bottom={ this.state.error ? <div>Сумма введена неверно<br/>(максимальная сумма возврата { this.state.maxSum } руб)</div> : '' }
                        id="input-refund"
                        maxLength={ 10 }
                    />
				</FormLayout>
				<FixedLayout vertical="bottom" className='fixed-bottom'>
					<Button size="xl" onClick={ this.openRefundProcess }>Оформить возврат</Button>
				</FixedLayout>
			</React.Fragment>
		)
	}
}

function mapStateToProps(state) {
    return {
        sum: state.bills.refund.sum,
        transactionId: state.bills.refund.transactionId,
        vkId: state.bills.refund.vkId,
    };
}

export default connect(mapStateToProps)(PanelRefund);


// WEBPACK FOOTER //
// ./src/js/panels/PanelRefund.js